export const MODAL_TYPES = {
  signIn: 'signIn',
  signUp: 'signUp',
  confirmRemove: 'confirmRemove',
  resetPassword: 'resetPassword',
  forgotPassword: 'forgotPassword',
  emailConfirm: 'emailConfirm',
  accountEmailConfirm: 'accountEmailConfirm',
  passwordChanged: 'passwordChanged',
  confirmCancel: 'confirmCancel',
  contactModal: 'contactModal',
  articleType: 'articleType',
  eventRegistration: 'eventRegistration',
  eventWaitlist: 'eventWaitlist',
  eventRegistrationSuccess: 'eventRegistrationSuccess',
  eventWaitlistSuccess: 'eventWaitlistSuccess',
} as const;

export const MODAL_VARIANTS = {
  emailConfirm: 'inform',
  accountEmailConfirm: 'confirm',
  confirm: 'confirm',
  confirmRemove: 'confirm',
  signIn: 'right',
  signUp: 'right',
  forgotPassword: 'right',
  resetPassword: 'right',
  passwordChanged: 'inform',
  confirmCancel: 'confirm',
  contactModal: 'contact',
  articleType: 'choose',
  eventRegistration: 'right',
  eventWaitlist: 'right',
  eventRegistrationSuccess: 'inform',
  eventWaitlistSuccess: 'inform',
};

export const AUTH_MODALS = [
  MODAL_TYPES.signIn,
  MODAL_TYPES.signUp,
  MODAL_TYPES.resetPassword,
  MODAL_TYPES.forgotPassword,
  MODAL_TYPES.emailConfirm,
] as const;
